import { Component, Input, OnInit } from '@angular/core';
import { Orcamento } from '../../../../models/orcamento.model';
import { OrcamentoService } from '../../../../services/orcamento.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-totais',
  templateUrl: './totais.component.html',
  styleUrl: './totais.component.scss'
})
export class TotaisComponent implements OnInit {
  orcamento: Orcamento | null = null;

  constructor(
    private route: ActivatedRoute,
    private toastService: ToastService,
    private orcamentoService: OrcamentoService,) {}

  ngOnInit(): void {
    const orcamentoId = this.route.snapshot.paramMap.get('id');

    if (orcamentoId && orcamentoId !== 'novo') {
      this.carregarOrcamento(orcamentoId);
    } else {
      this.toastService.show("Orçamento não encontrado", {
        classname: "bg-warning text-light",
      });
    }
  }

  carregarOrcamento(orcamentoId: string): void {

      this.orcamentoService.consultarOrcamento(orcamentoId).subscribe({
        next: (parametro: Orcamento) => {
          this.orcamento = parametro;
        },
        error: () => {
          this.toastService.show("Erro ao consultar orçamento", {
            classname: "bg-danger text-light",
          });
        },
        complete: () => {
  
        }
      });
    }
}
